/* eslint-disable camelcase */
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter, cardNumberFormatter } from '../../../../utils/formatting';
import DiscountFormatter from '../../DiscountFormatter';

const Card = ({
  tenderInfo, timezone,
}) => {
  const {
    isAdmin, locale: {
      momentFormat, storeLocale, storeCurrency
    },
    RL_ApprovalNumber, RL_Card, RL_CardNo, RL_AuthDate, TxRef, TxType, RL_Refund,
    RL_AuthNo, RL_CardName, RL_Mid, RL_Tid, RL_PrefName, RL_Aid, RL_TC, redacted,
    RL_InstallmentMonth, RL_Lumpsum, RL_Months
  } = useSelector((state) => state);
  const amount = (number) => currencyFormatter(storeLocale, storeCurrency, number);
  const formattedCardNumber = cardNumberFormatter(tenderInfo, redacted, isAdmin, storeLocale);
  const numberOfInstallments = () => {
    const installments = tenderInfo.Tender?.CreditDebit?.NumberOfInstallments;
    if (parseInt(installments, 10) === 0 || parseInt(installments, 10) === 1) {
      return RL_Lumpsum;
    } else {
      return `${parseInt(installments, 10)} ${RL_Months}`;
    }
  };

const isIndia = storeLocale === 'en-IN';

  const renderTransactionReference = () => {
    const refNumber = isIndia
      ? tenderInfo?.Tender?.Authorizations?.[0]?.ProviderReferenceNumber
      : tenderInfo?.Tender?.Authorizations?.[0]?.ReferenceNumber;

    if (!refNumber) return null;

    return (
      <article className="justify-between">
        <p className="pl2-sm">{isIndia ? 'Transaction ID' : TxRef}</p>
        <p className="pr2-sm">{refNumber}</p>
      </article>
    );
  };

  return (
    <>
      {(storeLocale !== 'ko-KR' || tenderInfo.Tender?.VendorIntegratedPayment) && (
      <article className="justify-between">
        <p>{isIndia && !tenderInfo.Tender?.SubTenderType ? RL_Card : tenderInfo.Tender?.SubTenderType}</p>
        <p>
          <DiscountFormatter isNegative={tenderInfo.Tender?.TypeCode === 'Refund'} storeLocale={storeLocale}>
            {amount(tenderInfo.Tender?.Amount?.Amount)}
          </DiscountFormatter>
          {tenderInfo.Tender?.SubTenderType === 'UPI' && <><br /></>}
        </p>
      </article>
      )}
      {(tenderInfo.Tender?.TypeCode === 'Refund') && (
        <>
          {!isIndia && (
            <article className="justify-between">
              <p className="pl2-sm">{RL_CardNo}</p>
              <p className="pr2-sm">{formattedCardNumber}</p>
            </article>
          )}
          {tenderInfo?.EndDateTime
            ? (
              <article className="justify-between">
                <p className="pl2-sm">{RL_AuthDate}</p>
                <p className="pr2-sm">{moment(tenderInfo?.EndDateTime).tz(timezone).format(`${momentFormat} HH:mm`)}</p>
              </article>
            )
            : ''}
          {renderTransactionReference()}
          <article className="justify-between">
            <p className="pl2-sm">{TxType}</p>
            <p className="pr2-sm">{RL_Refund}</p>
          </article>
          <br /><br />
        </>
      )}
      {/* Checking the global sale transaction or Korea sale and integrated payment to print the card details */}
      {((storeLocale !== 'ko-KR' && tenderInfo.Tender?.TypeCode !== 'Refund' && tenderInfo.Tender?.SubTenderType !== 'UPI') || (tenderInfo.Tender?.TypeCode === 'Sale' && tenderInfo.Tender?.VendorIntegratedPayment) || (isIndia && (tenderInfo.Tender?.SubTenderType === 'UPI'))) && (
        <>
          {!isIndia && (
            <article className="justify-between">
              <p className="pl2-sm">{RL_CardNo}</p>
              <p className="pr2-sm">{formattedCardNumber}</p>
            </article>
          )}
          {
             ['ko-KR', 'es-MX'].includes(storeLocale) && ('NumberOfInstallments' in tenderInfo.Tender?.CreditDebit) ? (
               <article className="justify-between">
                 <p className="pl2-sm">{RL_InstallmentMonth}</p>
                 {storeLocale === 'ko-KR' && <p className="pr2-sm">{numberOfInstallments()}</p>}
                 {storeLocale === 'es-MX' && <p className="pr2-sm">{tenderInfo.Tender?.CreditDebit?.NumberOfInstallments}</p>}
               </article>
             ) : ''
          }
          {!isIndia && tenderInfo?.Tender?.Authorizations?.[0].AuthorizationCode
            ? (
              <article className="justify-between">
                <p className="pl2-sm">{RL_AuthNo}</p>
                <p className="pr2-sm">{tenderInfo?.Tender?.Authorizations?.[0].AuthorizationCode}</p>
              </article>
            )
            : ''}
          {tenderInfo?.EndDateTime
            ? (
              <article className="justify-between">
                <p className="pl2-sm">{RL_AuthDate}</p>
                <p className="pr2-sm">{moment(tenderInfo?.EndDateTime).tz(timezone).format(`${momentFormat} HH:mm`)}</p>
              </article>
            )
            : ''}
          {renderTransactionReference()}
          {!isIndia && (
            <article className="justify-between">
              <p className="pl2-sm">{TxType}</p>
              <p className="pr2-sm">GOODS_SERVICES</p>
            </article>
          )}
          {tenderInfo?.Tender?.Authorizations?.[0].Mid
            ? (
              <article className="justify-between">
                <p className="pl2-sm">{RL_Mid}</p>
                <p className="pr2-sm">{tenderInfo?.Tender?.Authorizations?.[0].Mid}</p>
              </article>
            )
            : ''}
          {tenderInfo?.Tender?.Authorizations?.[0].AuthorizingTermID
            ? (
              <article className="justify-between">
                <p className="pl2-sm">{RL_Tid}</p>
                <p className="pr2-sm">{tenderInfo?.Tender?.Authorizations?.[0].AuthorizingTermID}</p>
              </article>
            )
            : ''}
          {tenderInfo?.Tender?.Authorizations?.[0].PrefName
            ? (
              <article className="justify-between">
                <p className="pl2-sm">{RL_PrefName}</p>
                <p className="pr2-sm">{tenderInfo?.Tender?.Authorizations?.[0].PrefName}</p>
              </article>
            )
            : ''}
          {tenderInfo?.Tender?.Authorizations?.[0].Aid
            ? (
              <article className="justify-between">
                <p className="pl2-sm">{RL_Aid}</p>
                <p className="pr2-sm">{tenderInfo?.Tender?.Authorizations?.[0].Aid}</p>
              </article>
            )
            : ''}
          {tenderInfo?.Tender?.Authorizations?.[0].TC
            ? (
              <article className="justify-between">
                <p className="pl2-sm">{RL_TC}</p>
                <p className="pr2-sm">{tenderInfo?.Tender?.Authorizations?.[0].TC}</p>
              </article>
            )
            : ''}
          <br /><br />
        </>
      )}
      {/* Checking the sale transaction for Korea non-integrated payment */}
      {((storeLocale === 'ko-KR' && !tenderInfo.Tender?.VendorIntegratedPayment && tenderInfo.Tender?.TypeCode !== 'Refund')) && (
      <>
        <article className="justify-between">
          <p>{RL_Card}</p>
          <p>{amount(tenderInfo.Tender?.Amount?.Amount)}</p>
        </article>
        <article className="justify-between">
          <p>{RL_CardName}</p>
          <p>N/A</p>
        </article>
        <article className="justify-between">
          <p>{RL_ApprovalNumber}</p>
          <p>00000</p>
        </article>
        <br /><br />
      </>
      )}
    </>
  );
};

Card.defaultProps = {
  tenderInfo: {},
  timezone: '',
};

Card.propTypes = {
  tenderInfo: PropTypes.shape(),
  timezone: PropTypes.string,
};

export default Card;
